import { render, staticRenderFns } from "./recipe-list.vue?vue&type=template&id=6f58e783&scoped=true"
import script from "./recipe-list.vue?vue&type=script&lang=js"
export * from "./recipe-list.vue?vue&type=script&lang=js"
import style0 from "./recipe-list.vue?vue&type=style&index=0&id=6f58e783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f58e783",
  null
  
)

export default component.exports